import { memo } from 'react';
import {
  DivHeadersList,
  Header,
  HeaderBar,
  Left,
} from '../OnBoardingModal.styles';
import { HeaderList } from './HeaderList';
import { IHeadingChildren, IHeadings } from '../helpers/HeadingsCalc';

interface LeftSideProps {
  isOnboarding: boolean;
  pages: IHeadings;
  activePageId: string;
  onPageChange: (child: IHeadingChildren) => void;
}

function LeftSide(props: LeftSideProps) {
  const { isOnboarding, pages, onPageChange, activePageId } = props;
  const headings = Array.from(pages.values());
  return (
    <Left>
      <HeaderBar className="left">
        <Header>{isOnboarding ? 'Onboard' : 'Mass Edit'}</Header>
      </HeaderBar>

      <DivHeadersList className="bscroll">
        {headings.map(heading => {
          return (
            <HeaderList
              key={heading.id}
              page={heading}
              onPageChange={onPageChange}
              activePageId={activePageId}
            />
          );
        })}
      </DivHeadersList>
    </Left>
  );
}
export default memo(LeftSide);
